module.exports = __webpack_public_path__ + "img/arrow_round_black.a8888cd5.svg";